<!-- #3 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 pb-0"
        style="color: #23468c; font-weight: 500"
      >
        Inbound Outbound Mapping List
      </div>
      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        class="ml-2 mr-8"
        v-if="checkPermission('app_pas:pas_inbound_outbound_mapping_upload')"
        @click="$router.push('/pas-projection-mapping')"
        >Upload</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      :headers="headers"
      :items="Pas"
      :loading="loader"
      class="elevation-1 custom-icon-size mr-8"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.mapping_updated_at`]="{ item }">
        <span v-if="item.mapping_updated_at">
          {{
            item.mapping_updated_at
              | uaeDateTime
              | moment("DD MMM, YYYY hh:mm A")
          }}<br /><span v-if="item.mapping_updated_by"
            >({{ item.mapping_updated_by }})</span
          >
        </span>
      </template>
      <template v-slot:[`item.mapping_created_at`]="{ item }">
        <span v-if="item.mapping_created_at">
          {{
            item.mapping_created_at
              | uaeDateTime
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        ><br /><span v-if="item.mapping_created_by"
          >({{ item.mapping_created_by }})</span
        >
      </template>

      <template v-slot:[`item.warehouse_id__name`]="{ item }">
        {{ item.warehouse_id__name }} <br />({{ item.wms_warehouse_code }})
      </template>
      <template v-slot:[`item.mapping_status`]="{ item }">
        <span
          :class="{
            'badge-active': item.mapping_status == 1,
            badge: item.mapping_status == 0,
            'badge-force': item.mapping_status === null,
          }"
        >
          {{
            item.mapping_status === null
              ? "Mapping Missing"
              : item.mapping_status == 1
              ? "Active"
              : "In-active"
          }}
        </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom v-if="checkPermission('app_pas:pas_projection_edit')">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="edit(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="warehousees"
                  outlined
                  v-model="wms_warehouse_code"
                  dense
                  label="Warehouse"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="storers"
                  outlined
                  v-model="storer_id"
                  dense
                  label="Storer"
                  item-text="storer_name"
                  item-value="id"
                  multiple
                  v-bind:search-input.sync="searchText"
                  @change="clearSearchText"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="token_number"
                  label="Token Number"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="inbound_receipt_no"
                  label="Inbound Receipt Number"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="inbound_receipt_key"
                  label="Inbound Receipt Key"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="outbound_receipt_no"
                  label="Outbound Receipt Number"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="outbound_order_key"
                  label="Outbound Order Key"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="types"
                  outlined
                  v-model="type"
                  dense
                  chips
                  small-chips
                  label="Mapping Type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="purposes"
                  outlined
                  v-model="token_type"
                  dense
                  chips
                  small-chips
                  label="Token Type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="statuses"
                  outlined
                  v-model="statusNew"
                  dense
                  label="Status"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" sm="6" class="pl-0">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class="mr-2"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    statusNew: 0,
    statuses: [
      { text: "Active", value: 1 },
      { text: "Inactive", value: 0 },
      { text: "Mapping Missing", value: "null" },
    ],
    searchText: "",
    status: 0,
    forcePushed: false,
    loader: false,
    ShowToken: "",
    options: {},
    timelinePopup: false,
    trackingDetails: [],
    token_number: null,
    purpose: null,
    storer_id: [],
    active: null,
    storers: [],
    latest_event_status: null,
    from_date: null,
    to_date: null,
    dateMenuTo: false,
    dateMenu: false,
    summary: false,
    vehicle_type: [],
    types: [
      {
        text: "Inbound",
        value: 1,
      },
      {
        text: "Outbound",
        value: 2,
      },
    ],

    purposes: [
      {
        text: "Inbound",
        value: 1,
      },
      {
        text: "Outbound",
        value: 2,
      },
      {
        text: "Both",
        value: 3,
      },
    ],
    tokenSummaryData: {
      payment_summary: {},
      order_details: {},
      shipping_address: {},
      billing_address: {},
    },
    headers: [
      {
        text: "Warehouse (Actual Warehouse)",
        value: "warehouse_id__name",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },
      {
        text: "Storer",
        value: "storer__storer_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Mapping Type",
        value: "type_str",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Token Number",
        value: "token_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Token Type",
        value: "token_type_str",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Inbound Receipt Key",
        value: "inbound_receipt_key",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Inbound Receipt Number",
        value: "inbound_receipt_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Outbound Order Key",
        value: "outbound_order_key",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Outbound Receipt Number",
        value: "outbound_receipt_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Created At(By)",
        value: "mapping_created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At(By)",
        value: "mapping_updated_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "mapping_status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    Pas: [],
    warehousees: [],

    wms_warehouse_code: null,
    total: 0,
    vehicles: [],
    forceitem: {},
    token_type: null,
    type: null,
    inbound_receipt_no: null,
    inbound_receipt_key: null,
    outbound_order_key: null,
    outbound_receipt_no: null,
  }),

  created() {
    this.fetchStore();
    if (this.$store.getters.user.user_category == 4) {
      this.active = 1;
      this.allFilters();
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchPas();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getPasProjectionMappingList",
      "snackBar",
      "pasTimeline",
      "fetchStorelist",
      "downloadPasData",
      "downloadPasTemplate",
      "forceCLoseApi",
    ]),
    clearSearchText() {
      this.searchText = ""; // Clears the search input after selection
    },
    edit(item) {
      this.$router.push({
        name: "PasProjectionCreate",
        query: { id: item.id },
      });
    },

    fetchStore() {
      this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
        this.vehicles = res.data.vehicle_types;
      });
    },
    timeline(item) {
      this.ShowToken = item.token_number;
      this.pasTimeline(item.id).then((res) => {
        this.timelinePopup = true;
        this.trackingDetails = res.data;
      });
    },

    fetchPas() {
      this.loader = true;
      this.allFilters();
      this.getPasProjectionMappingList({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.Pas = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    clearInput(val) {
      if (val == "this.from_date") {
        this.from_date = null;
      } else if (val == "this.to_date") {
        this.to_date = null;
      }
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.storer_id = [];
      this.wms_warehouse_code = null;
      (this.token_type = null),
        (this.type = null),
        (this.inbound_receipt_no = null),
        (this.inbound_receipt_key = null),
        (this.outbound_order_key = null),
        (this.outbound_receipt_no = null),
        (this.token_number = null),
        (this.statusNew = 0);
      this.searchAll();
    },

    allFilters() {
      this.loader = true;
      let obj = {
        token_type: this.token_type,
        type: this.type,
        inbound_receipt_no: this.inbound_receipt_no
          ? this.inbound_receipt_no.trim()
          : "",
        inbound_receipt_key: this.inbound_receipt_key
          ? this.inbound_receipt_key.trim()
          : "",
        outbound_order_key: this.outbound_order_key
          ? this.outbound_order_key.trim()
          : "",
        outbound_receipt_no: this.outbound_receipt_no
          ? this.outbound_receipt_no.trim()
          : "",
        token_number: this.token_number ? this.token_number.trim() : "",
        storer_id: this.storer_id ? this.storer_id.join(",") : "",
        wms_warehouse_code: this.wms_warehouse_code,
        active: this.statusNew,
      };
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
      this.loader = false;
    },
    async searchAll() {
      this.options.page = 1;
      await this.allFilters();
      this.getPasProjectionMappingList({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.Pas = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
<style lang="scss">
.v-btn--icon.v-size--default {
  height: 25px;
  width: 25px;
}
.p-0 {
  padding: 0px !important;
}

.layout.wrap.pt-3 {
  padding-left: 38px !important;
}
.card-title {
  padding-left: 22px;
}
.theme--light.v-data-table.custom-class
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  padding-left: 12px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.v-data-table.custom-class > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 12px;
}
.tl-item {
  margin: 0;
  padding: 0;
}
.v-timeline
  cutom-timeline
  v-timeline--align-top
  v-timeline--dense
  theme--light::before {
  left: 13px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-timeline .wrap {
  padding-left: 5px;
  padding-left: 0px;
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 9px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}

.mt {
  margin-top: 16px;
}
ul.tl li .item-detail {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
ul.tl li .timestamp {
  color: #8d8d8d;
  position: absolute;
  margin-left: -164px;
  text-align: right;
  font-size: 12px;
}
.history-tl-container-order {
  height: 55px;
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 31%;
  display: block;
  position: relative;
  top: -3px;
}

.history-tl-container-order ul.tl {
  padding: 0;
  display: inline-block;
}
.history-tl-container-order ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  // border-left: 1px solid black;
  padding: 0 0 20px 20px;
  // position: relative;
  // height: 45px;
  line-height: 1px;
}

/* Container for the vertical line and icon */
.vertical-line {
  position: relative;
  display: inline-block;
  left: -30px;
  top: 12px;
}

/* Vertical line */
.vertical-line::before {
  content: "";
  position: absolute;
  top: 16px;
  left: 43%;
  transform: translateX(-50%);
  height: 43px;
  width: 1px;
  background-color: black;
}

/* Icon */
.icon {
  position: relative; /* Ensure the icon is in front of the line */
  font-size: 24px; /* Adjust icon size as needed */
  z-index: 1; /* Place the icon above the line */
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-force {
  display: inline-block;
  padding: 4px 10px;
  background-color: orange;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 12px;
  text-align: center;
}
</style>
